import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { CameraControls } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
var VTCameraControls = forwardRef(function (_a, ref) {
    var screenShot = _a.screenShot, userMouseDown = _a.userMouseDown, userMouseUp = _a.userMouseUp, limitZoom = _a.limitZoom;
    var localRef = useRef(null);
    var _b = useThree(), gl = _b.gl, camera = _b.camera, scene = _b.scene;
    function lookAt(x, y, z, transition) {
        var _a;
        (_a = localRef.current) === null || _a === void 0 ? void 0 : _a.setLookAt(0, 0.1, 0, x, y, z, transition);
    }
    function moveTo(positionX, positionY, positionZ, lookAtX, lookAtY, lookAtZ, transition) {
        var _a;
        (_a = localRef.current) === null || _a === void 0 ? void 0 : _a.setLookAt(positionX, positionY, positionZ, lookAtX, lookAtY, lookAtZ, transition);
    }
    function save() {
        var _a;
        (_a = localRef.current) === null || _a === void 0 ? void 0 : _a.saveState();
    }
    function reset() {
        var _a;
        (_a = localRef.current) === null || _a === void 0 ? void 0 : _a.reset(true);
    }
    function fitToObject(ref, transition) {
        var _a;
        (_a = localRef.current) === null || _a === void 0 ? void 0 : _a.fitToBox(ref, transition);
    }
    function takeScreenShot() {
        gl.render(scene, camera);
        var screenshot = gl.domElement.toDataURL();
        screenShot(screenshot);
    }
    // Expose the function to the parent component
    useImperativeHandle(ref, function () { return ({
        lookAt: lookAt,
        moveTo: moveTo,
        save: save,
        reset: reset,
        takeScreenShot: takeScreenShot,
        fitToObject: fitToObject,
    }); }, []);
    return (_jsx(CameraControls, { ref: localRef, minDistance: limitZoom ? 0.1 : undefined, maxDistance: limitZoom ? 0.1 : undefined, 
        // These two invert the controls!
        azimuthRotateSpeed: -0.3, polarRotateSpeed: -0.3, enabled: true, makeDefault: true, onStart: function () {
            if (userMouseDown) {
                userMouseDown();
            }
        }, onEnd: function () {
            if (userMouseUp) {
                userMouseUp();
            }
        } }));
});
export default VTCameraControls;
